import type React from 'react';
import AkomiDialog from './AkomiDialog';

interface LoadingDialogProps {
  isOpen?: boolean;
  header?: string;
}

const LoadingDialog: React.FC<LoadingDialogProps> = ({ isOpen = true, header = '' }) => {
  return (
    <AkomiDialog open={isOpen} onClose={() => {}} title={header || undefined} loading skeletonRows={3} maxWidth="xs" />
  );
};

export default LoadingDialog;
